import Head from 'next/head';
import React from 'react';

export type HtmlMetaDataProps = {
  title?: string;
  descr?: string;
  author?: string;
  url?: string;
  robots?: string;
};

/**
 * Head component for metadata when logged in.
 */
const HtmlMetaData = (props: HtmlMetaDataProps): JSX.Element => {
  const {
    descr = "Osmosis is an efficient, enjoyable, and social way to learn. Sign up for an account today! Don't study it, Osmose it.",
    author,
    url = 'https://www.osmosis.org',
    robots,
  } = props;

  return (
    <Head>
      <link rel="canonical" href={url} />
      <meta httpEquiv="Content-Language" content="en" />
      <meta name="description" content={descr} />
      {author ? <meta name="author" content={author} /> : null}
      {robots ? <meta name="robots" content={robots} /> : null}
    </Head>
  );
};

export default HtmlMetaData;
